var map = {
	"./book/A4-P/sombra-capa-interna.svg": 962,
	"./book/A4-R/sombra-capa-interna.svg": 963,
	"./book/A5-P/sombra-capa-interna.svg": 964,
	"./book/A5-R/sombra-capa-interna.svg": 965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 961;